/************************************************************************
* RECORD-ACTIONS extension for datatables                               *
*************************************************************************/
(function ($) {
    var _createDropdownItem = function (record, fieldItem) {
        let $a = $("<a />")
            .addClass("dropdown-item")
            .addClass("datatable-action-button")
            .attr("href", "#");

        if (typeof fieldItem.isVisible !== "undefined" && fieldItem.isVisible !== null) {
            if (fieldItem.isVisible) {
                if (typeof fieldItem.isVisible === "function" && !fieldItem.isVisible.call($a.get(0), record)) {
                    return null;
                }
            } else {
                return null;
            }
        }

        if (fieldItem.buttonId) {
            $a.addClass(fieldItem.buttonId);
        }

        if (fieldItem.cssClass) {
            const cssClass = typeof fieldItem.cssClass === "function"
                ? fieldItem.cssClass.call($a.get(0), record)
                : fieldItem.cssClass;

            if (cssClass) {
                $a.addClass(cssClass);
            }
        }

        let $span = null;
        if (fieldItem.text) {
            const text = typeof fieldItem.text === "function"
                ? fieldItem.text(record)
                : fieldItem.text;

            if (text) {
                $span = $("<span />");

                try {
                    const $text = $(text);

                    if (!$text.length) {
                        $span.text(text);
                    } else {
                        $span.append($text);
                    }
                } catch (ex) {
                    $span.text(text);
                }
            }
        }

        let $i = null;
        if (fieldItem.iconClass) {
            const iconClass = typeof fieldItem.iconClass === "function"
                ? fieldItem.iconClass(record)
                : fieldItem.iconClass;

            if (iconClass) {
                $i = $("<i />").addClass(iconClass);
            }
        }

        if (app.isRTL()) {
            if ($span && $span.length > 0) {
                $a.append($span);
            }

            if ($i && $i.length > 0) {
                $a.append($i);
            }
        } else {
            if ($i && $i.length > 0) {
                $a.append($i);
            }

            if ($span && $span.length > 0) {
                $a.append($span);
            }
        }

        if (typeof fieldItem.isEnabled !== "undefined" && fieldItem.isEnabled !== null) {
            if (fieldItem.isEnabled) {
                if (typeof fieldItem.isEnabled === "function") {
                    if (fieldItem.isEnabled.call($a.get(0), record)) {
                        $a.removeClass("disabled");
                    } else {
                        $a.addClass("disabled");
                    }
                } else {
                    $a.removeClass("disabled");
                }
            } else {
                $a.addClass("disabled");
            }
        }

        if (fieldItem.transform) {
            $a = $(fieldItem.transform.call($a.get(0), record));
        }

        return $a.get(0);
    };

    /*
    actionButtons: [{
        showTextAsTooltip: bool - if true - the text is shown as tooltip instead of on the button itself,
        buttonId: string - should be a unique string to distinguish from the other action buttons, this will be added as a css class to action button, this is required when there is "action" is defined,
        text: string | HTML code | HTML element | jQuery object | function that returns all the previous - the text of the button that triggers the dropdown,
        cssClass: string | function - the CSS class of the button that triggers the dropdown,
        iconClass: string | function - the CSS class name of <i> tag (icons of eg: Font Awesome) for the dropdown button,
        isVisible: a bool | function that accepts a record and returns a bool (default: true) to indicate if the dropdown item should be shown,
        action: a function that accepts a record and doesn't return anything,
        isEnabled: a bool | function that accepts a record and returns a bool (default: true) to indicate if the dropdown item should be enabled (disabled dropdown item is grayed out and unselectable),
        transform: function,
        items: [ - the items of the dropdown menu (dropdown items)
            {
                buttonId: string - should be a unique string to distinguish from the other action buttons, this will be added as a css class to action button, this is required when there is "action" is defined,
                text: string | HTML code | HTML element | jQuery object | function that returns all the previous - the text of the dropdown item,
                cssClass: string | function - the CSS class name of the dropdown item,
                isVisible: a bool | function that accepts a record and returns a bool (default: true) to indicate if the dropdown item should be shown,
                action: a function that accepts a record and doesn't return anything,
                isEnabled: a bool | function that accepts a record and returns a bool (default: true) to indicate if the dropdown item should be enabled (disabled dropdown item is grayed out and unselectable),
                divider: a bool | function that indicates if this dropdown item is a divider and will not contain any text or codes,
                iconClass: string | function - the CSS class name of <i> tag (icons of eg: Font Awesome) for the dropdown item,
                transform: function
            }
        ]
    }]
     */
    var _createButtonDropdown = function (record, field) {
        let $button = $("<button />").addClass("datatable-action-button");
        let $container = $button;

        if (typeof field.isVisible !== "undefined" && field.isVisible !== null) {
            if (field.isVisible) {
                if (typeof field.isVisible === "function" && !field.isVisible.call($button.get(0), record)) {
                    return null;
                }
            } else {
                return null;
            }
        }

        if (field.buttonId) {
            $button.addClass(field.buttonId);
        }

        const hasChildren = field.items && field.items.length > 0;

        if (hasChildren) {
            $container = $("<div />").addClass("btn-group");

            // it's a dropdown button
            $button
                .addClass("dropdown-toggle")
                .attr("data-toggle", "dropdown")
                .attr("aria-haspopup", "true")
                .attr("aria-expanded", "false")
                .attr("data-boundary", "viewport")
                .appendTo($container);
        }

        if (field.cssClass) {
            const cssClass = typeof field.cssClass === "function"
                ? field.cssClass.call($button.get(0), record)
                : field.cssClass;

            if (cssClass) {
                $button.addClass(cssClass);
            }
        }

        let $span = null;
        if (field.text) {
            const text = typeof field.text === "function"
                ? field.text(record)
                : field.text;

            if (text) {
                $span = $("<span />").addClass("d-none d-md-inline-block d-lg-inline-block d-xl-inline-block");

                try {
                    const $text = $(text);

                    if (!$text.length || $.contains(document, $text.get(0))) {
                        $span.text(text);
                    } else {
                        $span.append($text);
                    }
                } catch (ex) {
                    $span.text(text);
                }
            }
        }

        let $i = null;
        if (field.iconClass) {
            const iconClass = typeof field.iconClass === "function"
                ? field.iconClass(record)
                : field.iconClass;

            if (iconClass) {
                $i = $("<i />").addClass(iconClass);
            }
        }

        if (field.showTextAsTooltip) {
            if ($i && $i.length > 0) {
                $button.append($i);

                if ($span && $span.length > 0) {
                    $container
                        .attr("data-toggle", "tooltip")
                        .attr("title", $span.text());
                }
            } else if ($span && $span.length > 0) {
                $button.append($span);
            } else {
                abp.log.warn("The button has no icon and text");
            }
        } else {
            if (app.isRTL()) {
                if ($span && $span.length > 0) {
                    $button.append($span);
                }

                if ($i && $i.length > 0) {
                    $button.append($i);
                }
            } else {
                if ($i && $i.length > 0) {
                    $button.append($i);
                }

                if ($span && $span.length > 0) {
                    $button.append($span);
                }
            }
        }

        if (hasChildren) {
            const $dropdownMenu = $("<div />").addClass("dropdown-menu action-dropdown-menu");

            if (app.isRTL()) {
                $dropdownMenu.addClass("dropdown-menu-right");
            }

            $.each(field.items, function () {
                const fieldItem = this;

                if (fieldItem.divider) {
                    const $divider = $("<div />").addClass("dropdown-divider");

                    if (fieldItem.divider === true) {
                        $dropdownMenu.append($divider);
                    } else if (typeof fieldItem.divider === "function") {
                        if (fieldItem.divider.call($divider.get(0), record)) {
                            $dropdownMenu.append($divider);
                        }
                    }

                    return;
                }

                const dropdownItem = _createDropdownItem(record, fieldItem);

                if (dropdownItem) {
                    $dropdownMenu.append(dropdownItem);
                }
            });

            if ($dropdownMenu.children().length > 0) {
                $container.append($button);
                $container.append($dropdownMenu);
            } else {
                return null;
            }
        }

        if (typeof field.isEnabled !== "undefined" && field.isEnabled !== null) {
            if (field.isEnabled) {
                if (typeof field.isEnabled === "function") {
                    $button.prop("disabled", !field.isEnabled.call($button.get(0), record));
                } else {
                    $button.prop("disabled", false);
                }
            } else {
                $button.prop("disabled", true);
            }
        }

        if (field.transform) {
            $button = $(field.transform.call($button.get(0), record));
        }

        return $container.get(0);
    };

    var _createRowAction = function (record, actionButtons) {
        if (actionButtons && actionButtons.length > 0) {
            const $container = $("<div />")
                .addClass("btn-group")
                .data("record", record);

            $.each(actionButtons, function () {
                const actionButton = this;

                const actionButtonElement = _createButtonDropdown(record, actionButton);
                if (actionButtonElement) {
                    $container.append(actionButtonElement);
                }
            });

            const $containerPlaceholder = $("<div />")
                .addClass("datatable-action-buttons-container-placeholder");

            $("<div />")
                .addClass("datatable-action-buttons-container")
                .append($container)
                .appendTo($containerPlaceholder);

            return $containerPlaceholder.get(0);
        }

        return null;
    };

    var hideColumnWithoutRedraw = function (tableInstance, colIndex) {
        tableInstance.fnSetColumnVis(colIndex, false, false);
    };

    var hideEmptyColumn = function (cellContent, tableInstance, colIndex) {
        if (cellContent === "") {
            hideColumnWithoutRedraw(tableInstance, colIndex);
        }
    };

    var renderRowActions = function (tableInstance, row, data) {
        const api = tableInstance.api();
        var columns = api.init()?.columnDefs;

        if (!columns) {
            return;
        }

        $.each(columns, function () {
            const column = this;
            if (column.actionButtons) {
                const actionPlaceholder = _createRowAction(data, column.actionButtons);
                //hideEmptyColumn($actionContainer, tableInstance, colIndex);

                if (actionPlaceholder) {
                    const $actionContainer = $(".datatable-action-buttons-container", actionPlaceholder);
                    $actionContainer.data("datatable-api", api);

                    $(row).find(`td.${column.className}`).empty().append(actionPlaceholder);

                    setTimeout(function () {
                        // explicitly set a width and height to the action buttons placeholder, so that when its inner container turned "absolute" positioned,
                        // it will not shrink/collapse and still retain its width and height.
                        const $actionPlaceholder = $(actionPlaceholder);
                        $actionPlaceholder.width($actionContainer.width());
                        $actionPlaceholder.height($actionContainer.height());
                    }, 100);
                }
            }
        });
    };

    if (!$.fn.dataTable) {
        return;
    }

    $.extend(true, $.fn.dataTable.defaults, {
        initComplete: (function () {
            const actionButtonClickEvent = function (api, buttonId, actionCallback) {
                if (buttonId && actionCallback) {
                    const dataTableId = $(api.table().container()).attr("id");
                    $(document).on(`click.${dataTableId}`, `#${dataTableId} .datatable-action-buttons-container .datatable-action-button.${buttonId}`, function (e) {
                        const actionButtonElement = this;
                        const $actionButtonElement = $(actionButtonElement);
                        const $actionButtonsContainer = $actionButtonElement.closest(".datatable-action-buttons-container");
                        const dropdownApi = $actionButtonsContainer.data("datatable-api");

                        if (api.table().node().isSameNode(dropdownApi.table().node())) {
                            if (!$actionButtonElement.hasClass("disabled")) {
                                e.preventDefault();

                                actionCallback.call(actionButtonElement, $actionButtonsContainer.children(".btn-group").data("record"), api);
                            }
                        }
                    });
                }
            };

            const original = $.fn.dataTable.defaults.initComplete;
            return function (settings, json) {
                original.apply(this, arguments);

                const api = new $.fn.dataTable.Api(settings);
                $(api.table().node()).on("destroy.dt", function (e, settings) {
                    const api = new $.fn.dataTable.Api(settings);
                    const dataTableId = $(api.table().container()).attr("id");
                    $(document).off(dataTableId);
                });

                const columns = api.init().columnDefs;

                if (!columns) {
                    return;
                }

                // Process the onclick event of buttons or dropdown items using event delegation so as not to register an event listener for the elements for every single row.
                $.each(columns, function () {
                    const column = this;
                    if (column.actionButtons && column.actionButtons.length > 0) {
                        $.each(column.actionButtons, function () {
                            const actionButton = this;

                            actionButtonClickEvent(api, actionButton.buttonId, actionButton.action);

                            if (actionButton.items && actionButton.items.length > 0) {
                                $.each(actionButton.items, function () {
                                    const item = this;

                                    actionButtonClickEvent(api, item.buttonId, item.action);
                                });
                            }
                        });
                    }
                });
            };
        })(),
        rowCallback: (function () {
            const original = $.fn.dataTable.defaults.rowCallback;
            return function (row, data, displayNum, displayIndex, dataIndex) {
                if (original) {
                    original.apply(this, arguments);
                }

                // data table's columns are being html encoded by default, therefore decode them first.
                if (_.isObject(data)) {
                    const d = {};
                    _.forOwn(data, (value, key) => {
                        if (_.isString(value)) {
                            d[key] = _.unescape(value);
                        } else {
                            d[key] = value;
                        }
                    });

                    data = d;
                } else if (_.isArray(data)) {
                    const d = [];
                    _.forEach(data, value => {
                        if (_.isString(value)) {
                            d.push(_.unescape(value));
                        } else {
                            d[key] = value;
                        }
                    });

                    data = d;
                }

                renderRowActions(this, row, data);
            };
        })()
    });

    $.fn.dataTable.customDefaults = $.fn.dataTable.customDefaults || {};
    $.fn.dataTable.customDefaults.columns = $.fn.dataTable.customDefaults.columns || {};
    $.extend(true, $.fn.dataTable.customDefaults.columns, {
        actions: {
            button: function (actionButtons) {
                return {
                    targets: "actions",
                    className: "actions",
                    searchable: false,
                    orderable: false,
                    autoWidth: false,
                    defaultContent: "",
                    actionButtons: actionButtons
                };
            }
        }
    });

    $.fn.dataTable.customDefaults.columns.actions.button.default = function (dropdownItems, actionButtonText, actionButtonCssClass, actionButtonIconClass) {
        return $.fn.dataTable.customDefaults.columns.actions.button([
            {
                showTextAsTooltip: false,
                text: typeof actionButtonText !== "undefined" ? actionButtonText : app.localize("Actions"),
                cssClass: typeof actionButtonCssClass !== "undefined" ? actionButtonCssClass : "btn btn-primary btn-sm",
                iconClass: typeof actionButtonIconClass !== "undefined" ? actionButtonIconClass : "fad fa-cog",
                items: dropdownItems
            }]);
    };

    $.fn.dataTable.customDefaults.rows = $.fn.dataTable.customDefaults.rows || {};
    $.fn.dataTable.customDefaults.rows.events = $.fn.dataTable.customDefaults.rows.events || {};
    $.fn.dataTable.customDefaults.rows.events.updated = function (record, api) {
        if (!record.id || parseInt(record.id) === 0) {
            if (api.newId == null || api.newId == undefined) {
                api.newId = 0;
            }

            record.id = --api.newId;

            api.row
                .add(record)
                .draw();
        } else {
            api.row(`#${record.id}`)
                .data(record)
                .invalidate()
                .draw();
        }

        app.dataTables.adjustColumns(api.table().container());
    };
    $.fn.dataTable.customDefaults.rows.events.deleted = function (record, api) {
        const data = api.row(`#${record.id}`).data();
        //data.lastChangeStatus = data.changeStatus;
        //data.changeStatus = app.enums.changeStatus.deleted;
        api.row(`#${record.id}`)
            .data(data)
            .invalidate()
            .draw();

        app.dataTables.adjustColumns(api.table().container());
    };

    // manually show and hide dropdown because the Fixed Header feature of Datatables clips the dropdown (since the dropdown is confined in a relative positioned container)
    $(document).on("show.bs.dropdown", ".dataTable", function (e) {
        const $target = $(e.target);
        $target.closest("tr").trigger("mouseleave"); // return the floating action buttons to the original position.

        const $dataTable = $(this);
        const $dropdownGroup = $target.parent(".btn-group");
        const api = $dataTable.DataTable();

        let $container = $(api.table().container());

        // grab the menu
        const offset = $target.getAncestorOffset($container);
        const $dropdownGroupClone = $dropdownGroup.clone();

        $dropdownGroup.data("active-dropdown", $dropdownGroupClone);

        $dropdownGroup.after($dropdownGroupClone);
        // detach it and append it to the body
        const $dropdownGroupContainer = $("<div />")
            .data("datatable-api", api)
            .addClass("datatable-dropdown-container")
            .addClass("datatable-action-buttons-container")
            .addClass("position-absolute")
            .css({
                top: offset.top,
                left: offset.left
            });
        $dropdownGroupContainer.append($dropdownGroup);

        $container.append($dropdownGroupContainer);
    });

    // and when you hide it, reattach the drop down, and hide it normally                                                   
    $(document).on("hide.bs.dropdown", ".datatable-dropdown-container", function (e) {
        const $dropdownGroup = $(e.target).parent(".btn-group");
        const $dropdownGroupContainer = $dropdownGroup.parent(".datatable-dropdown-container");
        const $dropdownButton = $dropdownGroup.data("active-dropdown");

        const api = $dropdownGroupContainer.data("datatable-api");
        api.table().node().focus({ preventScroll: true });

        $dropdownButton.before($dropdownGroup);
        $dropdownButton.remove();
        $dropdownGroupContainer.remove();
    });

    $(window).resize(function () {
        const $dropdownGroupContainer = $(".datatable-dropdown-container");
        if ($dropdownGroupContainer.length > 0) {
            const $dropdownGroup = $(".datatable-dropdown-container").children();
            const $dropdownButton = $dropdownGroup.data("active-dropdown");

            const offset = $dropdownButton.offset();
            $dropdownGroupContainer
                .css({
                    top: offset.top,
                    left: offset.left
                });
        }
    });
})(jQuery);
